/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Report_Unattributed_NoticeInputs */



/**
* | output |
* | --- |
* | "{amount} of metered usage could not be attributed to a plan and was never billed. It is in no total on this page." |
*
* @param {Report_Unattributed_NoticeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const report_unattributed_notice = /** @type {((inputs: Report_Unattributed_NoticeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Unattributed_NoticeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} gemessene Nutzung konnte keinem Tarif zugeordnet werden und wurde nie berechnet. Sie steckt in keiner Summe auf dieser Seite.`)
	return /** @type {LocalizedString} */ (`${i?.amount} of metered usage could not be attributed to a plan and was never billed. It is in no total on this page.`)
});